import { Box, SxProps } from '@mui/material';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import React from 'react';
import { colors } from '../utils/theme';

export const RootineDataGrid = ({
  dataGridProps,
  hasCustomHeader = false,
  boxStyles,
}: {
  dataGridProps: DataGridProps;
  hasCustomHeader: boolean;
  boxStyles?: SxProps;
}): JSX.Element => {
  return (
    <Box sx={{ width: '100%', ...boxStyles }}>
      <DataGrid
        autoHeight
        sx={{
          borderRadius: 1.25,
          borderTopLeftRadius: hasCustomHeader ? 0 : 4,
          borderTopRightRadius: hasCustomHeader ? 0 : 4,
          border: `1px solid ${colors.greys.BORDER_GREY}`,
          backgroundColor: colors.greys.BASE_WHITE,
          boxShadow: hasCustomHeader
            ? 'none'
            : '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: colors.greys.GREY_50,
            color: colors.greys.BRAND_BLACK,
            fontSize: 14,
          },
          '.MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none',
          },
        }}
        {...dataGridProps}
      />
    </Box>
  );
};
